import {getUri} from "../../../../utils/utils";


export default function BlogPostAnimation({className, ...props}) {

    return (
        <div className={"w-full animate-pulse  lg:flex-1 flex flex-col gap-[32px]"}>

            <div className={"bg-gray-200 rounded-full w-1/2 h-3"}/>
            <div className={"flex flex-col gap-2"}>
                <div className={"w-full bg-gray-200 h-4 rounded-full  font-bold"}/>
                <div className={"bg-gray-200 rounded-full w-1/2 h-4"}/>
            </div>
            <div
                className={"w-full rounded-md bg-gray-200 h-[55vh] object-cover "}
            />
            <div className={"flex flex-col gap-2"}>
                <div className={"w-full bg-gray-200 h-3 rounded-full  font-bold"}/>
                <div className={"bg-gray-200 rounded-full w-1/2 h-3"}/>
            </div>
            <div className={"flex flex-col gap-2"}>
                <div className={"w-full bg-gray-200 h-3 rounded-full  font-bold"}/>
                <div className={"w-full bg-gray-200 h-3 rounded-full  font-bold"}/>
                <div className={"w-full bg-gray-200 h-3 rounded-full  font-bold"}/>
                <div className={"w-full bg-gray-200 h-3 rounded-full  font-bold"}/>
                <div className={"w-full bg-gray-200 h-3 rounded-full  font-bold"}/>
                <div className={"bg-gray-200 rounded-full w-1/2 h-3"}/>
                <div className={"w-full bg-gray-200 h-3 rounded-full mt-4 font-bold"}/>
                <div className={"w-full bg-gray-200 h-3 rounded-full  font-bold"}/>
                <div className={"w-full bg-gray-200 h-3 rounded-full  font-bold"}/>
                <div className={"w-full bg-gray-200 h-3 rounded-full  font-bold"}/>
                <div className={"w-full bg-gray-200 h-3 rounded-full  font-bold"}/>
                <div className={"bg-gray-200 rounded-full w-1/2 h-3"}/>
                <div className={"w-full bg-gray-200 h-3 rounded-full mt-4 font-bold"}/>
                <div className={"w-full bg-gray-200 h-3 rounded-full  font-bold"}/>
                <div className={"w-full bg-gray-200 h-3 rounded-full  font-bold"}/>
                <div className={"w-full bg-gray-200 h-3 rounded-full  font-bold"}/>
                <div className={"w-full bg-gray-200 h-3 rounded-full  font-bold"}/>
                <div className={"bg-gray-200 rounded-full w-1/2 h-3"}/>
            </div>
        </div>

    )
}